import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SafeUrlPipe } from '../models/safe-url.pipe';

@Component({
  selector: 'app-sigma-dashboard',
  templateUrl: './sigma-dashboard.component.html',
  styleUrls: ['./sigma-dashboard.component.css'],
  standalone: true,
  imports: [NgIf,SafeUrlPipe]
})
export class SigmaDashboardComponent implements OnInit {

  @Input() embedUrl: string;
  public hasError: boolean = false;

  constructor() {}

  ngOnInit() {}

  onIframeLoad() {
    this.hasError = false;
  }

  onIframeError() {
    this.hasError = true;
  }

}
